<template>
  <div>
    <view-x-selector />
    <v-btn
      color="primary"
      class="mr-2"
      @click="$root.$emit(exportEvent)"
    >
      <v-icon
        small
        left
      >
        mdi-file-excel
      </v-icon>
      Excel
    </v-btn>
    <v-btn
      v-print="printObj"
      color="success"
    >
      Print/PDF
    </v-btn><div
      v-show="printLoading"
      id="loading"
    />
    <!--    <button @click="generateReport">PDF</button>-->
    <!--    <div>-->
    <!--      <vue-html2pdf-->
    <!--        :show-layout="false"-->
    <!--        ref="html2Pdf"-->
    <!--        :float-layout="true"-->
    <!--        :enable-download="true"-->
    <!--        :preview-modal="true"-->
    <!--        :paginate-elements-by-height="1400"-->
    <!--        filename="hee hee"-->
    <!--        :pdf-quality="2"-->
    <!--        :manual-pagination="false"-->
    <!--        pdf-format="a4"-->
    <!--        pdf-orientation="landscape"-->

    <!--        pdf-content-width="800px"-->
    <!--      >-->
    <!--        <section slot="pdf-content">-->

    <!--        </section>-->
    <!--      </vue-html2pdf>-->
    <!--    </div>-->

    <div
      id="printMe"
      class="print-black"
    >
      <router-view />
    </div>
  </div>
</template>

<script>
  import ViewXSelector from '@/views/dashboard/components/ViewXSelector'
  import VueHtml2pdf from 'vue-html2pdf'
  import { mapState } from 'vuex'
  import moment from 'moment'
  export default {
    name: 'ReportBase',
    components: {
      ViewXSelector,
      VueHtml2pdf,
    },
    computed: {
      ...mapState('records', ['view', 'currentDate', 'startDate', 'endDate']),
      exportEvent () {
        if (this.$route.name === 'manHourReport') return 'export-manhour-excel'
        if (this.$route.name === 'leaveReport') return 'export-leavereport-excel'
        return 'export-detailtime-excel'
      },
    },
    data: () => ({
      printLoading: true,
      printObj: {
        id: 'printMe',
        popTitle: 'Tik Time Report',
        //         extraCss: `
        //   div {
        //     color: black;
        //     font-family: sans-serif;
        //   }
        // `,
        // extraHead: '<meta http-equiv="Content-Language"content="zh-cn"/>',
        beforeOpenCallback (vue) {
          vue.printLoading = true
          console.log('打开之前')
        },
        openCallback (vue) {
          vue.printLoading = false
          console.log('执行了打印')
        },
        closeCallback (vue) {
          console.log('关闭了打印工具')
        },
      },
    }),
    watch: {
      startDate () {
        this.printObj.popTitle = `Tik Time Report :: From ${moment(this.startDate).format('MMM DD YYYY')} to ${moment(this.endDate).format('MMM DD YYYY')}  `
      },
      endDate () {
        this.printObj.popTitle = `Tik Time Report :: From ${moment(this.startDate).format('MMM DD YYYY')} to ${moment(this.endDate).format('MMM DD YYYY')}  `
      },

    },
    methods: {
      generateReport () {
        this.$refs.html2Pdf.generatePdf()
      },
    },

  }
</script>

<style scoped>

</style>
